import { useState } from "react";
import { faqs } from "@/mocks/gua";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);
  return (
    <section className="mt-16 px-4 md:mt-24 md:px-6">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 lg:grid-cols-3">
        <div>
          <p className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-secondary-600">
            <i className="ri-question-answer-line" /> 常见问题
          </p>
          <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
            关于「深度吃瓜」，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            我们怎么选材、怎么求证、如何避免带节奏？这些问题，下面一次说清。
          </p>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-2">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-close-line" : "ri-add-line"} text-sm`} />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 pb-4 md:px-5 md:pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}